import Component from './component.vue';

export *  from './types';

export default Component;



// WEBPACK FOOTER //
// ./src/components/modal/default/index.ts